<template>
    <div>
        <header class="page-header">
            <h2>
                <a href="/dashboard">
                    <i class="fa fa-list-alt"></i>
                </a>
            </h2>
            <ol class="breadcrumbs">
                <li class="active">
                    <span>Dashboard</span>
                </li>
            </ol>
        </header>
        <div class="row">
            <div class="col-lg-8">
                <div class="card">
                    <div class="card-body p-0">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="chart-data-selector ready pl-3 pr-4 pt-4">
                                    <div class="chart-data-selector-items">
                                        <chart-line v-if="loaded" :data="dataChartLine"></chart-line>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row px-4 mt-2 pb-3">
                            <div class="col-2 font-weight-bold text-primary">{{ year }}</div>
                            <div class="col-10 font-weight-semibold text-right">Comprobantes generados por mes</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="row">
                    <div class="col-md-12">
                        <section class="card card-horizontal">
                            <header class="card-header bg-success">
                                <div class="card-header-icon">
                                    <i class="fas fa-users"></i>
                                </div>
                            </header>
                            <div class="card-body p-4 text-center">
                                <p class="font-weight-semibold mb-0 mx-4">Total Clientes</p>
                                <h2 class="font-weight-semibold mt-0">{{ records.length }}</h2>
                                <div class="summary-footer">
                                    <a class="text-muted text-uppercase" href="#client-list">Ver todos</a>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div class="col-md-12 mb-0">
                        <section class="card card-horizontal">
                            <header class="card-header bg-info">
                                <div class="card-header-icon">
                                    <i class="fas fa-file-alt"></i>
                                </div>
                            </header>
                            <div class="card-body p-4 text-center">
                                <p class="font-weight-semibold mb-0 mt-3">Total Comprobantes</p>
                                <h2 class="font-weight-semibold mt-0 mb-3">{{ total_documents }}</h2>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <section class="card card-featured-left card-featured-primary mb-4">
                    <div class="card-body">
                        <div class="widget-summary widget-summary-md">
                            <div class="widget-summary-col widget-summary-col-icon">
                                <div class="summary-icon text-secondary">
                                    <div :data-value='discUsed' class="progress1 mx-auto">
                                        <span class="progress1-left">
                                            <span class="progress1-bar border-primary"></span>
                                        </span>
                                        <span class="progress1-right">
                                            <span class="progress1-bar border-primary"></span>
                                        </span>
                                        <div
                                            class="progress1-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                            <div class="font-weight-bold">{{ discUsed }}<small class="small"></small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-summary-col">
                                <div class="summary">
                                    <h4 class="title"><!-- Disco <br> Duro --></h4>
                                    <div class="info">
                                        <strong class="amount">Disco Duro</strong><br>
                                        <!-- <span class="text-warning" v-if="discUsed == 0">no se pudo obtener</span> -->
                                    </div>
                                </div>
                                <div class="summary-footer d-block">
                                    <a class="text-muted text-uppercase"
                                        href="https://docs.google.com/document/d/1hpEQUs9OFha_35yyLb1cMKeluD-dEku5lQsQ3TJFib8/edit"
                                        target="BLANK">Incrementar</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="col-md-3">
                <section class="card card-featured-left card-featured-primary mb-4">
                    <div class="card-body">
                        <div class="widget-summary widget-summary-md">
                            <div class="widget-summary-col widget-summary-col-icon">
                                <div class="summary-icon">
                                    <i class="far fa-bell text-secondary"></i>
                                </div>
                            </div>
                            <div class="widget-summary-col">
                                <div class="summary">
                                    <h4 class="title"><!-- Disco <br> Duro --></h4>
                                    <div class="info">
                                        <strong class="amount">
                                            {{ totalDocumentNotSent }}
                                        </strong>
                                        <!-- <span class="text-primary">(14 unread)</span> -->
                                    </div>
                                </div>
                                <div class="summary-footer d-block">
                                    <span class="text-muted">
                                        <strong>POR ENVIAR</strong>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="col-md-3">
                <section class="card card-featured-left card-featured-primary mb-4">
                    <div class="card-body">
                        <div class="widget-summary widget-summary-md">
                            <div class="widget-summary-col widget-summary-col-icon">
                                <div class="summary-icon">
                                    <i class="fas fa-exclamation-triangle text-secondary"></i>
                                </div>
                            </div>
                            <div class="widget-summary-col">
                                <div class="summary">
                                    <h4 class="title"><!-- Disco <br> Duro --></h4>
                                    <div class="info">
                                        <strong class="amount">
                                            {{ totalDocumentRegularizeShipping }}
                                        </strong>
                                        <!-- <span class="text-primary">(14 unread)</span> -->
                                    </div>
                                </div>
                                <div class="summary-footer d-block">
                                    <span class="text-muted">
                                        <strong>POR RECTIFICACION</strong>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="col-md-3">
                <section class="card card-featured-left card-featured-primary mb-4">
                    <div class="card-body">
                        <div class="widget-summary widget-summary-md">
                            <div class="widget-summary-col widget-summary-col-icon">
                                <div class="summary-icon">
                                    <i class="fas fa-exclamation-circle text-secondary"></i>
                                </div>
                            </div>
                            <div class="summary">
                                <h4 class="title"><!-- Disco <br> Duro --></h4>
                                <div class="info">
                                    <strong class="amount">
                                        {{ totalDocumentToBeCanceled }}
                                    </strong>
                                    <!-- <span class="text-primary">(14 unread)</span> -->
                                </div>
                            </div>
                            <div class="summary-footer d-block">
                                <span class="text-muted">
                                    <strong>POR ANULAR</strong>
                                </span>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <div id="client-list" class="card">
            <div class="card-header bg-info">Listado de Clientes</div>
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <button class="btn btn-custom btn-sm mt-2 mr-2 mb-3" type="button"
                            @click.prevent="clickCreate()">
                            <i class="fa fa-plus-circle"></i> Nuevo
                        </button>
                    </div>
                </div>
                <div class="data-table-visible-columns mb-3">
                    <el-dropdown :hide-on-click="false">
                        <el-button type="primary" size="small">
                            Mostrar / Ocultar columnas
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="(col, key) in Object.values(columns)" :key="key">
                                <el-checkbox v-model="col.visible">{{ col.title }}</el-checkbox>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th v-if="columns.hostname.visible">Hostname</th>
                                <th v-if="columns.name.visible">Nombre</th>
                                <th v-if="columns.number.visible">RUC</th>
                                <th v-if="columns.plan.visible">Plan</th>
                                <th v-if="columns.email.visible">Correo</th>
                                <th v-if="columns.soap_type.visible">Entorno</th>
                                <th v-if="columns.count_doc.visible" class="text-center">Total de Comprobantes</th>
                                <th v-if="columns.document_not_sent.visible" class="text-center">
                                    <div>Notificaciones</div>
                                </th>
                                <th v-if="columns.start_billing_cycle.visible" class="text-right">Inicio Ciclo
                                    Facturacion</th>
                                <th v-if="columns.doc_quantity.visible" class="text-center">Comprobantes Ciclo
                                    Facturacion</th>
                                <th v-if="columns.count_user.visible" class="text-center">Usuarios</th>

                                <th v-if="columns.establishments.visible" class="text-center">Establecimientos</th>

                                <th v-if="columns.monthly_sales_total.visible" class="text-center">Ventas (Mes)</th>


                                <th v-if="columns.created_at.visible" class="text-center">F.Creación</th>
                                <th v-if="columns.queries_to_apiperu.visible" class="text-center">Consultas <br>API Peru
                                    <br>(mes)
                                </th>

                                <th v-if="columns.count_sales_notes.visible" class="text-center">Cant.Notas de venta
                                </th>
                                <th v-if="columns.current_count_doc_month.visible" class="text-center">
                                    Total<br><small>(Comprobantes por mes)</small></th>
                                <th v-if="columns.count_doc_pse.visible" class="text-center">
                                    Total<br><small>(Comprobantes a PSE)</small></th>
                                <th v-if="columns.count_doc_sales_notes_month.visible" class="text-center">
                                    Total<br><small>(Comprobantes <br>notas de venta)</small></th>

                                <th v-if="columns.locked_tenant.visible" class="text-center">Bloquear cuenta</th>

                                <th v-if="columns.locked_emission.visible" class="text-right">Limitar Doc.</th>
                                <th v-if="columns.locked_users.visible" class="text-center">Limitar Usuarios</th>

                                <th v-if="columns.locked_create_establishments.visible" class="text-center">Limitar
                                    Establecimientos</th>

                                <th v-if="columns.restrict_sales_limit.visible" class="text-center">
                                    <el-tooltip class="item"
                                        content="Límite de ventas mensual asociado al ciclo de facturación"
                                        effect="dark" placement="top">
                                        <label>Limitar Ventas (Mes)</label>
                                    </el-tooltip>
                                </th>


                                <th v-if="columns.options.visible" class="text-right">Acciones</th>
                                <!-- <th class="text-right">Pagos</th>
                            <th class="text-right">E. Cuenta</th>
                            <th class="text-right">Editar</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in records" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td v-if="columns.hostname.visible">
                                    <!-- {{ row.hostname }} -->
                                    <a :href="`http://${row.hostname}`" style="color:black" target="_blank">{{
                                        row.hostname }}</a>
                                </td>
                                <td v-if="columns.name.visible">{{ row.name }}</td>
                                <td v-if="columns.number.visible">{{ row.number }}</td>
                                <td v-if="columns.plan.visible">{{ row.plan }}</td>
                                <td v-if="columns.email.visible">{{ row.email }}</td>
                                <td v-if="columns.soap_type.visible">
                                    <span v-if="row.soap_type == '01'" class="badge badge-default">Demo</span>
                                    <span v-if="row.soap_type == '02'" class="badge badge-success">Producción</span>
                                    <span v-if="row.soap_type == '03'" class="badge badge-info">Interno</span>
                                </td>
                                <td class="text-center" v-if="columns.count_doc.visible">
                                    <label>
                                        <strong>{{ row.count_doc }}</strong>
                                    </label>
                                </td>

                                <td class="text-center" v-if="columns.document_not_sent.visible">

                                    <el-tooltip class="item" content="Comprobantes enviados / por enviar" effect="dark"
                                        placement="top-start">
                                        <el-badge :value="row.document_not_sent" class="item"
                                            :type="row.document_not_sent == 0 ? 'primary' : 'danger'">
                                            <i class="far fa-bell text-secondary"></i>
                                        </el-badge>
                                    </el-tooltip>

                                    <el-tooltip class="item" content="Comprobantes pendientes de rectificación"
                                        effect="dark" placement="top-start">
                                        <el-badge :value="row.document_regularize_shipping" class="item  ml-4"
                                            :type="row.document_regularize_shipping == 0 ? 'primary' : 'danger'">
                                            <i class="fas fa-exclamation-triangle text-secondary"></i>
                                        </el-badge>
                                    </el-tooltip>

                                    <el-tooltip class="item" content="Comprobantes por anular" effect="dark"
                                        placement="top-start">
                                        <el-badge :value="row.document_to_be_canceled" class="item  ml-4"
                                            :type="row.document_to_be_canceled == 0 ? 'primary' : 'danger'">
                                            <i class="fas fa-exclamation-circle text-secondary"></i>
                                        </el-badge>
                                    </el-tooltip>

                                </td>
                                <td v-if="columns.start_billing_cycle.visible">
                                    <template v-if="row.start_billing_cycle">
                                        <span></span>
                                        <span>{{ row.start_billing_cycle }}</span>
                                    </template>
                                    <template v-else>
                                        <el-date-picker v-model="row.select_date_billing" placeholder="..." type="date"
                                            value-format="yyyy-MM-dd"
                                            @change="setStartBillingCycle($event, row.id)"></el-date-picker>
                                    </template>
                                </td>

                                <td class="text-center" v-if="columns.doc_quantity.visible">
                                    <strong>
                                        <template v-if="row.sale_notes_quantity_if_include > 0">
                                            {{ row.count_doc_month ? (row.count_doc_month +
                                                row.sale_notes_quantity_if_include) : 0 }} /
                                        </template>
                                        <template v-else>
                                            {{ row.count_doc_month ? row.count_doc_month : 0 }} /
                                        </template>

                                        <template v-if="row.max_documents == 0">
                                            <i class="fas fa-infinity"></i>
                                        </template>
                                        <template v-else>
                                            <strong>{{ row.max_documents }}</strong>
                                        </template>
                                    </strong>
                                </td>

                                <td class="text-center" v-if="columns.count_user.visible">
                                    <template v-if="row.max_users !== 0 && row.count_user > row.max_users">
                                        <el-popover :content="text_limit_users" placement="top-start" trigger="hover"
                                            width="220">
                                            <label slot="reference" class="text-danger">
                                                <strong>{{ row.count_user }}</strong>
                                            </label>
                                        </el-popover>
                                    </template>
                                    <template v-else>
                                        <label>
                                            <strong>{{ row.count_user }}</strong>
                                        </label>
                                    </template>
                                    /
                                    <template v-if="row.max_users == 0">
                                        <i class="fas fa-infinity"></i>
                                    </template>
                                    <template v-else>
                                        <strong>{{ row.max_users }}</strong>
                                    </template>
                                </td>

                                <td class="text-center" v-if="columns.establishments.visible">

                                    <data-limit-notification entity_description="establecimientos"
                                        :unlimited="row.establishments_unlimited"
                                        :quantity="row.quantity_establishments"
                                        :max_quantity="row.max_quantity_establishments">
                                    </data-limit-notification>

                                </td>

                                <td class="text-center" v-if="columns.monthly_sales_total.visible">

                                    <data-limit-notification entity_description="ventas"
                                        style_div="width: 150px !important" :unlimited="row.sales_unlimited"
                                        :quantity="row.monthly_sales_total" :max_quantity="row.max_sales_limit">
                                    </data-limit-notification>

                                </td>


                                <td class="text-center" v-if="columns.created_at.visible">{{ row.created_at }}</td>
                                <td v-if="columns.queries_to_apiperu.visible">{{ row.queries_to_apiperu }}</td>

                                <td class="text-center" v-if="columns.count_sales_notes.visible"><strong>{{
                                    row.count_sales_notes }}</strong></td>
                                <td class="text-center" v-if="columns.current_count_doc_month.visible"><strong>{{
                                    row.current_count_doc_month
                                        }}</strong></td>
                                <td class="text-center" v-if="columns.count_doc_pse.visible"><strong>{{
                                    row.count_doc_pse }}</strong></td>
                                <td class="text-center" v-if="columns.count_doc_sales_notes_month.visible"><strong>{{
                                    row.count_doc_month +
                                    row.count_sales_notes_month
                                        }}</strong></td>

                                <td class="text-center" v-if="columns.locked_tenant.visible">
                                    <template v-if="!row.locked">
                                        <el-switch v-model="row.locked_tenant" style="display: block"
                                            @change="changeLockedTenant(row)"></el-switch>
                                    </template>
                                </td>

                                <td class="text-center" v-if="columns.locked_emission.visible">
                                    <el-switch v-model="row.locked_emission" style="display: block"
                                        @change="changeLockedEmission(row)"></el-switch>
                                </td>

                                <td class="text-center" v-if="columns.locked_users.visible">
                                    <el-switch v-model="row.locked_users" style="display: block"
                                        @change="changeLockedUser(row)"></el-switch>
                                </td>

                                <td class="text-center" v-if="columns.locked_create_establishments.visible">
                                    <el-switch v-model="row.locked_create_establishments" style="display: block"
                                        @change="changeLockedByColumn(row, 'locked_create_establishments')"></el-switch>
                                </td>

                                <td class="text-center" v-if="columns.restrict_sales_limit.visible">
                                    <el-switch v-model="row.restrict_sales_limit" style="display: block"
                                        @change="changeLockedByColumn(row, 'restrict_sales_limit')"></el-switch>
                                </td>

                                <td class="text-right" v-if="columns.options.visible">
                                    <!-- <template v-if="!row.locked">
                                    <el-tooltip content="Se ingresa con el RUC"
                                                placement="top">
                                        <button
                                            class="btn waves-effect waves-light btn-xs btn-info m-1__2"
                                            type="button"
                                            @click.prevent="clickPassword(row.id)"
                                        >Restablecer contraseña
                                        </button>
                                    </el-tooltip>
                                    <button
                                        v-if="deletePermission == true"
                                        class="btn waves-effect waves-light btn-xs btn-danger m-1__2"
                                        type="button"
                                        @click.prevent="clickDelete(row)"
                                    >Eliminar Cliente
                                    </button>
                                </template> -->
                                    <div class="dropdown">
                                        <button class="btn btn-default btn-sm" type="button" id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="fas fa-ellipsis-v"></i>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <template v-if="!row.locked">
                                                <a class="dropdown-item" href="#"
                                                    @click.prevent="clickPassword(row.id)">
                                                    Restablecer contraseña
                                                </a>
                                                <a class="dropdown-item" href="#" @click.prevent="clickDelete(row)"
                                                    v-if="deletePermission == true">
                                                    Eliminar Cliente
                                                </a>
                                                <div class="dropdown-divider"></div>
                                            </template>
                                            <a class="dropdown-item" href="#" @click.prevent="clickEdit(row.id)">
                                                Editar
                                            </a>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" href="#" @click.prevent="clickPayments(row.id)">
                                                Pagos
                                            </a>
                                            <a class="dropdown-item" href="#"
                                                @click.prevent="clickAccountStatus(row.id)">
                                                Estado de cuenta
                                            </a>
                                        </div>
                                    </div>
                                </td>
                                <!-- <td class="text-right">
                                <button
                                    class="btn waves-effect waves-light btn-xs btn-warning m-1__2"
                                    type="button"
                                    @click.prevent="clickPayments(row.id)"
                                >Pagos
                                </button>
                            </td>
                            <td class="text-right">
                                <button
                                    class="btn waves-effect waves-light btn-xs btn-primary m-1__2"
                                    type="button"
                                    @click.prevent="clickAccountStatus(row.id)"
                                >E. Cuenta
                                </button>
                            </td>
                            <td class="text-right">
                                <button
                                    class="btn waves-effect waves-light btn-xs btn-primary m-1__2"
                                    type="button"
                                    @click.prevent="clickEdit(row.id)"
                                >Editar
                                </button>
                            </td> -->



                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <system-clients-form :recordId="recordId" :showDialog.sync="showDialog"></system-clients-form>

        <!--<system-clients-form-edit :showDialog.sync="showDialogEdit"
        :recordId="recordId"></system-clients-form-edit>-->

        <client-payments :clientId="recordId" :showDialog.sync="showDialogPayments"></client-payments>

        <account-status :clientId="recordId" :showDialog.sync="showDialogAccountStatus"></account-status>

        <client-delete :record="record" :showDialog.sync="showDialogDelete"></client-delete>
    </div>
</template>

<script>
import CompaniesForm from "./form.vue";
//   import CompaniesFormEdit from './form_edit.vue'
import { deletable } from "../../../mixins/deletable";
import { changeable } from "../../../mixins/changeable";
import ChartLine from "./charts/Line";
import ClientPayments from "./partials/payments.vue";
import AccountStatus from "./partials/account_status.vue";
import ClientDelete from "./partials/delete.vue";
import DataLimitNotification from "./partials/DataLimitNotification.vue";

export default {
    mixins: [
        deletable,
        changeable
    ],
    props: [
        'deletePermission',
        'discUsed',
        'iUsed',
        'storageSize',
        'version'
    ],
    components: {
        CompaniesForm,
        ChartLine,
        ClientPayments,
        AccountStatus,
        ClientDelete,
        DataLimitNotification
    },
    data() {
        return {
            selectBillingDate: "",
            showDialogEdit: false,
            showDialog: false,
            showDialogPayments: false,
            showDialogAccountStatus: false,
            resource: "clients",
            recordId: null,
            records: [],
            text_limit_doc: null,
            text_limit_users: null,
            loaded: false,
            year: moment().format('YYYY'),
            total_documents: 0,
            dataChartLine: {
                labels: null,
                datasets: [
                    {
                        // label: 'Data One',
                        // backgroundColor: '#f87979',
                        data: null
                    }
                ]
            },
            showDialogDelete: false,
            record: {},
            columns: {
                hostname: { title: 'Hostname', visible: true },
                name: { title: 'Nombre', visible: true },
                number: { title: 'RUC', visible: true },
                plan: { title: 'Plan', visible: true },
                email: { title: 'Correo', visible: true },
                soap_type: { title: 'Entorno', visible: true },
                count_doc: { title: 'Total de Comprobantes', visible: true },
                document_not_sent: { title: 'Notificaciones', visible: true },
                start_billing_cycle: { title: 'Inicio Ciclo Facturacion', visible: false },
                doc_quantity: { title: 'Comprobantes Ciclo Facturacion', visible: false },
                count_user: { title: 'Usuarios', visible: false },
                establishments: { title: 'Establecimientos', visible: false },
                monthly_sales_total: { title: 'Ventas (Mes)', visible: false },
                created_at: { title: 'F.Creación', visible: false },
                queries_to_apiperu: { title: 'Consultas', visible: false },
                count_sales_notes: { title: 'Cant.Notas de venta', visible: false },
                current_count_doc_month: { title: 'Comprobantes por mes', visible: false },
                count_doc_pse: { title: 'Comprobantes a PSE-GIOR', visible: false },
                count_doc_sales_notes_month: { title: 'Comprobantes <br>notas de venta', visible: false },
                locked_tenant: { title: 'Bloquear cuenta', visible: true },
                locked_emission: { title: 'Limitar Doc.', visible: false },
                locked_users: { title: 'Limitar Usuarios', visible: false },
                locked_create_establishments: { title: 'Limitar Establecimientos', visible: false },
                restrict_sales_limit: { title: 'Limitar Ventas (Mes)', visible: false },
                options: { title: 'Acciones', visible: true }
            },
        };
    },
    async mounted() {
        this.loaded = false;
        await this.$http.get(`/${this.resource}/charts`).then(response => {
            let line = response.data.line;
            this.dataChartLine.labels = line.labels;
            this.dataChartLine.datasets[0].data = line.data;
            this.total_documents = response.data.total_documents;
            // console.log(response.data)
            // this.records = response.data.data
        });
        this.loaded = true;
    },
    created() {
        this.$eventHub.$on("reloadData", () => {
            this.getData();
        });
        this.getData();

        this.text_limit_doc = "El límite de comprobantes fue superado";
        this.text_limit_users = "El límite de usuarios fue superado";
    },
    computed: {
        totalDocumentNotSent() {
            return this.records.reduce((sum, row) => sum + (Number(row.document_not_sent) || 0), 0);
        },
        totalDocumentRegularizeShipping() {
            return this.records.reduce((sum, row) => sum + (Number(row.document_regularize_shipping) || 0), 0);
        },
        totalDocumentToBeCanceled() {
            return this.records.reduce((sum, row) => sum + (Number(row.document_to_be_canceled) || 0), 0);
        }
    },
    methods: {
        changeLockedTenant(row) {
            this.$http
                .post(`${this.resource}/locked_tenant`, row)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                        this.$eventHub.$emit("reloadData");
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        this.$message.error(error.response.data.message);
                    } else {
                        console.log(error.response);
                    }
                })
                .then(() => {
                });
        },

        changeLockedUser(row) {
            this.$http
                .post(`${this.resource}/locked_user`, row)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                        this.$eventHub.$emit("reloadData");
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        this.$message.error(error.response.data.message);
                    } else {
                        console.log(error.response);
                    }
                })
                .then(() => {
                });
        },
        changeLockedByColumn(row, column) {
            const params = { ...row }
            params.column = column

            this.$http
                .post(`${this.resource}/locked-by-column`, params)
                .then(response => {

                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.$eventHub.$emit("reloadData")
                    }
                    else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        this.$message.error(error.response.data.message)
                    }
                    else {
                        console.log(error.response)
                    }
                })
                .then(() => {
                })
        },
        setStartBillingCycle(event, id) {
            this.$http
                .post(`${this.resource}/set_billing_cycle`, {
                    id: id,
                    start_billing_cycle: event
                })
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        this.$message.error(error.response.data.message);
                    } else {
                        console.log(error.response);
                    }
                })
                .then(() => {
                    this.$eventHub.$emit("reloadData");
                });
        },
        changeLockedEmission(row) {
            this.$http
                .post(`${this.resource}/locked_emission`, row)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                        this.$eventHub.$emit("reloadData");
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        this.$message.error(error.response.data.message);
                    } else {
                        console.log(error.response);
                    }
                })
                .then(() => {
                });
        },
        getData() {
            this.$http.get(`/${this.resource}/records`).then(response => {
                this.records = response.data.data;
            });
        },
        clickCreate(recordId = null) {
            this.recordId = recordId;
            this.showDialog = true;
        },
        clickPayments(recordId = null) {
            this.recordId = recordId;
            this.showDialogPayments = true;
        },
        clickAccountStatus(recordId = null) {
            this.recordId = recordId;
            this.showDialogAccountStatus = true;
        },
        clickPassword(id) {
            this.change(`/${this.resource}/password/${id}`);
        },
        clickDelete(record) {

            this.record = record
            this.showDialogDelete = true
            // this.destroy(`/${this.resource}/${id}`).then(() =>
            //     this.$eventHub.$emit("reloadData")
            // );
        },
        clickEdit(recordId) {
            this.recordId = recordId;
            this.showDialog = true;
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/js/views/system/clients/index.vue